<template>
    <EtatAddEdit apiName="getEtatEmp"  :idEtat="state.EtatAddEdit" :isOpen="state.openCloseEtatAddEdit" :key="state.openCloseEtatAddEdit" @closeEtatAddEdit="state.openCloseEtatAddEdit = 0"/>    
</template>
      
<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import EtatAddEdit from "./EtatAddEdit.vue";
import { useRouter } from "vue-router";

export default defineComponent({
    name: "General",
    components : {
        EtatAddEdit,
    },
    setup() {

        const router = useRouter();

        const state = reactive({
            EtatAddEdit : 0 as any,
            openCloseEtatAddEdit : 0,
        });

        onMounted(async() => {
            if (router.currentRoute.value.params.id) {
                state.EtatAddEdit = router.currentRoute.value.params.id;
                state.openCloseEtatAddEdit = 1;
            } 
        });
            
        return {
            state,
        };
    },
});
</script>